import React from 'react';
import { TeamSearchMainDiv } from '../styles';
import SearchFilters from './SearchFilters';
import SearchHeading from './SearchHeading';
import GearsList from './GearsList';

const GearsInfoSection = ({
  allOrgGears,
  postsPerPage,
  currentPage,
  setCurrentPage,
  editGear,
  handleNameFilterChange,
  handleDeviceTypeFilterChange,
  handleSubStatusFilterChange,
  nameFilter,
  deviceTypeFilter,
  subStatusFilter,
}) => {
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    let totalPages = Math.ceil(allOrgGears.length / postsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <TeamSearchMainDiv>
      <SearchFilters
        nameFilter={nameFilter}
        handleNameFilterChange={handleNameFilterChange}
        handleDeviceTypeFilterChange={handleDeviceTypeFilterChange}
        deviceTypeFilter={deviceTypeFilter}
        handleSubStatusFilterChange={handleSubStatusFilterChange}
        subStatusFilter={subStatusFilter}
      />
      <SearchHeading/>
      <GearsList
        editGear={editGear}
        allOrgGears={allOrgGears}
        nameFilter={nameFilter}
        deviceTypeFilter={deviceTypeFilter}
        subStatusFilter={subStatusFilter}
        indexOfFirstPost={indexOfFirstPost}
        indexOfLastPost={indexOfLastPost}
        postsPerPage={postsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        prePage={prePage}
        nextPg={nextPage}
      />
    </TeamSearchMainDiv>
  );
};

export default GearsInfoSection;
